import { render, staticRenderFns } from "./OnboardingSeekingOptions.vue?vue&type=template&id=1c74c05c&"
import script from "./OnboardingSeekingOptions.vue?vue&type=script&lang=js&"
export * from "./OnboardingSeekingOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports